import React from "react";

const Focus = () => {
  return (
    <div>
      <h2 className="mt-35" style={{ backgroundColor: "#3f4db6" }}>
        OUR FOCUS
      </h2>
      <div className="row justify-content-center section-title mt-25">
        <div className="col-md ">
          <h2>Digital Transformation and Innovation </h2>
          <p>
            Our main focus is to help organizations and business enterprises to
            create ,transform and sustain digital innovation through agile
            development and modern development methodologies of digital
            products.We accelerate digital innovation and transformation across
            Africa
          </p>
        </div>
        <div className="col-md single-counter count-down-wrapper">
          <span className="counter">
            <h2 className="mt-3">9 </h2>
          </span>
          <p style={{ fontSize: "17px" }}>
            <span style={{ backgroundColor: "#3f4db6" }}>
              talented
              <br /> engineers
            </span>
          </p>
        </div>
        <div className="col-md">
          <h2>Agile Approach</h2>
          <p>
            Our approach is fast, flexible, and collaborative. All AkilTech
            clients have direct access to our leadership team, plus a designated
            Product Manager who is responsible for making sure we thoroughly
            understand client expectations and deliver to them.
          </p>
        </div>
      </div>
      <div className="row justify-content-center section-title mt-60">
        <div className="col-md single-counter count-down-wrapper">
          <span className="counter mb-50">
            <h2 className="mt-3 ">2019 </h2>
          </span>
          <p style={{ fontSize: "17px" }}>
            <span style={{ backgroundColor: "#ff9100" }}>
              year
              <br /> founded
            </span>
          </p>
        </div>
        <div className="col-md ">
          <h2> SMEs </h2>
          <p>
            One of our top policy priority is enabling SME
            digitalization.Emerging technologies, offer a range of applications
            for SMEs to improve performance and overcome the size-related
            limitations they face in doing business.SMEs make the most of the
            industrial fabric in many countries and regions, they create jobs
            (most jobs sometimes) and are the cement of inclusive and
            sustainable societies.{" "}
          </p>
        </div>

        <div className="col-md">
          <h2>Tech Innovation Hub</h2>
          <p>
            There is no reason why the future should happen only in Silicon
            Valley.AkilTech also focuses largely on bringing new approaches and
            technologies to fruitful application.We help in the development of
            technology-based companies , new products ,services or improving
            existing ideas on the market.
          </p>
        </div>
      </div>
      <div className="row justify-content-center section-title mt-60">
        <div className="col-md">
          <h2>Educational Technology</h2>
          <p>
            AkilTech works with private institutions ,government organizations
            and founders to create digital platforms and softwares that helps to
            facilitate collaboration in active learning environments.We help
            teachers and educational content delivery organizations to integrate
            new technologies and tools into their className room. We also
            strongly believe that engineers' jobs are also to teach.We offer
            internship programs for young web developers and software engineers
            in order to assist transform technology education in Africa and
            share our skill set.
          </p>
        </div>
        <div className="col-md single-counter  section-title count-down-wrapper">
          <span className="counter ">
            <h2 className="mt-3">90k+ </h2>
          </span>
          <p style={{ fontSize: "17px" }}>
            <span style={{ backgroundColor: "#3f4db6" }}>
              Lines
              <br />
              of code completed
            </span>
          </p>
        </div>
        <div className="col-md " />
      </div>
    </div>
  );
};

export default Focus;
